import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {DataResponse} from '../../../network/service/data.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {Config} from '../../../common/config';

@Component({
  selector: 'app-profile',
  standalone: false,
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent extends BaseComponent implements OnInit {
  firstName?: any;
  lastName?: any;
  mobile?: any;
  nationalCode?: any;
  email?: any;
  birthDate?: any;
  userInformation?: any;

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getUserInformation().subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.userInformation = res.data;
        this.onDataPrepared();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  onDataPrepared() {
    this.firstName = this.userInformation?.FirstName;
    this.lastName = this.userInformation?.LastName;
    this.mobile = this.userInformation?.MobileNumber;
    this.nationalCode = this.userInformation?.NationalCode;
    this.email = this.userInformation?.Email;
    this.birthDate = this.userInformation?.BirthDate;
  }

  openBackClicked() {
    this.location.back();
  }

  onSubmitClicked() {
    this.serviceApi.putUpdateProfile({
      FirstName: this.firstName,
      LastName: this.lastName,
      NationalCode: this.nationalCode,
      Email: this.email,
      BirthDate: this.birthDate
    }).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        Config.userInformation = res.data.dataValues;
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }
}
